import {DeviceSize} from '../../../shared/theme/helpers';
import {useStyles} from '../../../shared/hooks/styles';

export const GetStyles = () => {
  return useStyles(({theme, mediaOnly}) => ({
    container: {
      borderRadius: 14,
      backgroundColor: theme.socialSupportMeasures.link.backgroundColor,
      shadowColor: theme.socialSupportMeasures.link.shadowColor,
      shadowOpacity: 0.1,
      shadowOffset: {width: 0, height: 2},
      shadowRadius: 18,
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 25,
      paddingBottom: 25,
      position: 'relative',
      overflow: 'hidden',
      height: 80,
      flexDirection: 'row',
      alignItems: 'center',
    },
    text: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h4Light, theme.fonts.bodySmall),
      color: theme.socialSupportMeasures.link.textColor,
    },
  }));
};
